

























import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { Power4, TimelineLite } from 'gsap'
import { Meta } from '@/decorators/meta'

// import Animation from '@/mixins/Animation.vue'

import ModuleGallery from '@/components/ModuleGallery.vue'
import ModuleVideo from '@/components/ModuleVideo.vue'
import ModuleShowcase from '@/components/ModuleShowcase.vue'

@Component({
  components: { ModuleGallery, ModuleVideo, ModuleShowcase }
})
export default class Project extends Vue {
  $api: any
  $refs: any
  project = null
  projectLoaded = false
  prev = null
  next = null
  currentIndex = 0
  prevActive = false
  nextActive = false
  timeline = new TimelineLite()

  options = {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    css3: true,
    scrollingSpeed: 1000,
    controlArrows: false,
    afterLoad: this.afterLoad,
    onLeave: this.onLeave
  }

  @Action('setLightMode') setLightMode
  @Action('setTitle') setTitle
  @Action('updateAnimation') updateAnimation

  @Getter('animationEnded') animationEnded

  @Watch('animationEnded', { immediate: true })
  async showArrows(ready) {
    await this.fetchSiblings()

    if (!ready) {
      this.prevActive = false
      this.nextActive = false
    }

    if (this.prev && ready) {
      this.prevActive = true
    }

    if (this.next && ready) {
      this.nextActive = true
    }
  }

  @Meta
  metas() {
    return {
      title: 'Projects',
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  get pageLoaded() {
    return this.projectLoaded
  }

  get projectTitle() {
    return this.project ? this.project.title.rendered : ''
  }

  afterLoad(from, origin) {
    this.currentIndex = origin.index
  }

  onLeave() {
    this.setLightMode()
  }

  async fetchProject() {
    const res = await this.$api.project.fetchProject(this.$route.params.slug)
    this.project = res.data.length ? res.data[0] : null
    this.projectLoaded = res.data.length ? true : false
  }

  async fetchSiblings() {
    const res = await this.$api.project.fetchProjects()
    const index = res.data.findIndex((project) => {
      return project.id === this.project.id
    })
    this.prev = index > 0 ? res.data[index - 1] : null
    this.next = index < res.data.length - 1 ? res.data[index + 1] : null
  }


  async mounted() {
    await this.fetchProject()
    // this.timeline.staggerFrom(this.$refs.header, 1, { y: -20 })

  }

  arrow(event) {
    if (event.keyCode === 37 && this.prev) {
      this.goPrevProject()
    }

    if (event.keyCode === 39 && this.next) {
      this.goNextProject()
    }
  }

  goPrevProject() {
    this.setTitle(this.prev.title.rendered)
    this.$router.push({ name: 'project', params: { slug: this.prev.slug } })
  }

  goNextProject() {
    this.setTitle(this.next.title.rendered)
    this.$router.push({ name: 'project', params: { slug: this.next.slug } })

  }

  created() {
    this.updateAnimation(false)
    window.addEventListener('keyup', this.arrow)
  }

  beforeDestroy() {
   window.removeEventListener('keyup', this.arrow)
  }

  goNextSlide() {
    this.$refs.fullpage.api.moveSectionDown()
  }

  goPrevSlide() {
    this.$refs.fullpage.api.moveSectionUp()
  }

}
